<template lang="pug">
  div.item.journals.body
    div.toolbar-filter
      e-form-search-filter(
        :formValidator="formValidator"
        @apply="applyFilter"
        @reset="resetFilter"
      )
        div.one-row
          e-form-group(
            formGroupStyle="filter-block"
            label="Дата и время редактирования"
            inputType="calendar-range"
            :model="filterModel"
            tabView="tab1"
            name="start_date"
            toName="end_date"
            valueFormat="timestamp"
          ).period
          e-form-group(
            formGroupStyle="filter-block"
            label="Старое значение"
            :model="filterModel"
            name="from"
            tabView="tab1"
          )
          e-form-group(
            formGroupStyle="filter-block"
            label="Новое значение"
            :model="filterModel"
            name="to"
            tabView="tab1"
          )
          e-form-search-filter-buttons(
            :loading="searchInProgress"
          ).filter-block
    
    e-table-inner(
      ref="log"
      :visibleColumns="logVisibleColumns"
      :itemsEndpoint="getEndpoint"
      :showDeleteButton="false"
      :showEditButton="false"
      :showCheckbox="false"
    )
      template(slot="to" slot-scope="props")
        e-journal-json-log(
          :jsonStringOrObject="props.row.to"
          :jsonStringOrObjectPrev="props.row.from"
        )
      template(slot="from" slot-scope="props")
        e-journal-json-log(
          :jsonStringOrObject="props.row.from"
          :jsonStringOrObjectPrev="props.row.to"
          :markNulledAsCreated="false"
        )
</template>

<script>
  import { journal } from '@/api/api-endpoints'
  import tableMixin from '../../components/table/table-mixin.js'
  
  const FilterModel = () => ({
    start_date: '',
    end_date: '',
    from: '',
    to: '',
    types: ['update'],
    _type: 'update'
  })
  
  export default {
    name: 'ChangeLogTab',
    mixins: [tableMixin],
    props: {
      entityId: {
        type: [Number, String],
        default: null
      },
      moduleId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        filterModel: new FilterModel()
      }
    },
    computed: {
      logVisibleColumns() {
        return {
          create_at: { label: 'Дата и время изменения' },
          from: { label: 'Старое значение' },
          to: { label: 'Новое значение' },
          user_name: { label: 'Пользователь' }
        }
      },
      tableId() {
        return 'log_' + this.entityId
      }
    },
    methods: {
      applyFilter() {
        this.$refs.log.fetchData()
      },
      resetFilter() {
        this.filterModel = new FilterModel()
      },
      getEndpoint(ctx) {
        if (!this.entityId) {
          return { url: null }
        }
        let route = { query: {} }
        if (this.filterModel.start_date) {
          route.query.start_date = Math.round(this.filterModel.start_date / 1000) || ''
        }
        if (this.filterModel.end_date) {
          route.query.end_date = Math.round(this.filterModel.end_date / 1000) || ''
        }
        if (this.filterModel.from) {
          route.query.from = this.filterModel.from
        }
        if (this.filterModel.to) {
          route.query.to = this.filterModel.to
        }
        if (ctx && ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }
        if (ctx && ctx.paginateObj && ctx.paginateObj.page) {
          route.query.page = ctx.paginateObj.page
        }
        if (ctx && ctx.paginateObj && ctx.paginateObj['per-page']) {
          route.query.page = ctx.paginateObj['per-page']
        }
        
        route.query._type = 'update'
        route.query.types = ['update']
        route.query.labelFor_type = 'Отредактированные'
        route.query.entity_id = this.entityId
        route.query.module_id = this.moduleId
        return { url: journal.userAll(route) }
      }
    }
  }
</script>

<style scoped lang="scss">
   .main-layout .body {
      display: block!important;
   }
  .toolbar-filter {
    margin-top: 0 !important;
    > div {
      display: inline-block!important;
    }
  }
  .body button, td button {
    width: 100%!important;
  }
</style>